import { post } from '@/utils/request'

/**
 * 淘客关注公众号的二维码
 */
export default function taoke_follow_wx_qrcode(data) {
  return post('taoke_follow_wx_qrcode', data)
}